<script lang="ts">
  import { ALL_DASHBOARD_ROLES, DASHBOARD_TITLES, resolveDashboardRole, type DashboardRole } from '../../lib/dashboard/resolve';
  import { dashboardPreview } from '../../lib/dashboard/preview.svelte';
  import { session } from '../../lib/auth.svelte';

  const BUILD = '';

  const selected = $derived(
    dashboardPreview.role ?? resolveDashboardRole(session.value?.roles),
  );

  function onChange(e: Event) {
    const v = (e.currentTarget as HTMLSelectElement).value as DashboardRole;
    dashboardPreview.role = v === 'admin' ? null : v;
  }
</script>

<div class="picker" data-build={BUILD}>
  <div class="picker-left">
    <span class="badge"></span>
    <span class="build">{BUILD}</span>
  </div>
  <label class="picker-select">
    <span>Rol operativo</span>
    <select value={selected} onchange={onChange} aria-label="Seleccionar dashboard por rol">
      {#each ALL_DASHBOARD_ROLES as r (r)}
        <option value={r}>{DASHBOARD_TITLES[r]}</option>
      {/each}
    </select>
  </label>
  <p class="hint">12 vistas exclusivas · datos reales del backend · distinto layout por rol</p>
</div>

<style>
  .picker {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.65rem 1rem;
    padding: 0.75rem 1rem;
    margin-bottom: 0.85rem;
    background: linear-gradient(90deg, color-mix(in srgb, var(--brand-deep) 8%, var(--bg-elevated)), var(--bg-elevated));
    border: 2px solid var(--brand);
    border-radius: var(--radius-md);
    box-shadow: 0 4px 16px color-mix(in srgb, var(--brand) 15%, transparent);
  }
  .picker-left { display: flex; align-items: center; gap: 0.5rem; }
  .badge {
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--brand-deep);
    background: var(--brand-soft);
    padding: 0.25rem 0.55rem;
    border-radius: 6px;
  }
  .build { font-size: 0.68rem; color: var(--text-secondary); font-family: ui-monospace, monospace; }
  .picker-select { display: flex; flex-direction: column; gap: 0.15rem; margin-left: auto; }
  .picker-select span { font-size: 0.68rem; font-weight: 600; color: var(--text-secondary); text-transform: uppercase; }
  select {
    padding: 0.45rem 0.65rem;
    border-radius: 8px;
    border: 1px solid var(--brand);
    background: var(--bg-surface);
    font: inherit;
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--brand-deep);
    min-width: 16rem;
  }
  .hint {
    flex: 1 1 100%;
    margin: 0;
    font-size: 0.78rem;
    color: var(--text-secondary);
  }
</style>
